import i18n from '../i18n'

interface ApiErrorLike {
  response?: { status?: number; data?: { error?: string; message?: string; code?: string } }
  message?: string
}

// apiErrorMessage turns an axios error into a user-facing text. Backend errors
// arrive as {error, message?}; 403 permission_denied is shown as a plain
// "no permission" notice (with the missing permission if the backend names it).
export function apiErrorMessage(e: unknown, fallback?: string): string {
  const err = e as ApiErrorLike
  const data = err?.response?.data
  if (err?.response?.status === 403) {
    const perm = /missing permission:\s*(\S+)/i.exec(data?.message ?? data?.error ?? '')?.[1]
    const base = i18n.t('common.noPermission', 'Keine Berechtigung für diese Aktion')
    return perm ? `${base} (${perm})` : base
  }
  const text = data?.message || data?.error
  if (text) return text
  if (err?.response == null) return i18n.t('common.networkError', 'Server nicht erreichbar')
  return fallback ?? i18n.t('common.error', 'Fehler')
}
